import React, { useState, useEffect } from 'react';
import { Form, Button, Modal, Row, Tab, Tabs } from 'react-bootstrap';

export default function ModalMultiSelect({ show, handleClose, dataItem, setRenderRows }) {

  const [validated, setValidated] = useState(false);
  const conditionView = (dataItem.typeView === 'View' || dataItem.typeView === 'Delete') ? true : false;
  const setCloseButton = <><Button variant="secondary" onClick={handleClose}> Close </Button> {'  '}  {'  '} </>;

  return (
    <>
      <Modal size="sm" show={show} onHide={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title> {dataItem.typeView} {dataItem.nameView} </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Tabs
            defaultActiveKey="main"
            id="justify-tab-example"
            className="mb-3"
            justify
          >
            <Tab eventKey="main" title={"Data " + dataItem.nameView}>

              Codes <pre>
                {JSON.stringify(dataItem.codeItem, null, 2)}
              </pre>

              <hr></hr>
              {setCloseButton}
            </Tab>
          </Tabs>

        </Modal.Body>
      </Modal>
    </>
  );
}